// src/styles/theme.js
export const PRESET_THEMES = {
  modern: {
    light: {
      bg: '#f8fafc',
      secondary: '#e2e8f0',
      text: '#1e293b',
      textSecondary: '#64748b',
      accent: '#7c3aed', // Vibrant purple
      card: '#ffffff',
      linkBg: '#7c3aed20',
      linkText: '#7c3aed',
      linkHoverBg: '#7c3aed30',
    },
    dark: {
      bg: '#0f172a',
      secondary: '#1e293b',
      text: '#f1f5f9',
      textSecondary: '#94a3b8',
      accent: '#8b5cf6', // Lighter purple for dark mode
      card: '#1e293b',
      linkBg: '#8b5cf620',
      linkText: '#a78bfa',
      linkHoverBg: '#8b5cf640',
    }
  },
  ocean: {
    light: {
      bg: '#f0f9ff',
      secondary: '#e0f2fe',
      text: '#0c4a6e',
      textSecondary: '#0369a1',
      accent: '#0ea5e9',
      card: '#ffffff',
      linkBg: '#0ea5e920',
      linkText: '#0ea5e9',
      linkHoverBg: '#0ea5e930',
    },
    dark: {
      bg: '#0c4a6e',
      secondary: '#075985',
      text: '#e0f2fe',
      textSecondary: '#bae6fd',
      accent: '#0ea5e9',
      card: '#164e63',
      linkBg: '#0ea5e920',
      linkText: '#38bdf8',
      linkHoverBg: '#0ea5e940',
    }
  },
  amber: {
    light: {
      bg: '#fffbeb',
      secondary: '#fef3c7',
      text: '#78350f',
      textSecondary: '#92400e',
      accent: '#f59e0b',
      card: '#ffffff',
      linkBg: '#f59e0b20',
      linkText: '#d97706',
      linkHoverBg: '#f59e0b30',
    },
    dark: {
      bg: '#451a03',
      secondary: '#78350f',
      text: '#fef3c7',
      textSecondary: '#fbbf24',
      accent: '#f59e0b',
      card: '#78350f',
      linkBg: '#f59e0b20',
      linkText: '#fbbf24',
      linkHoverBg: '#f59e0b40',
    }
  },
  emerald: {
    light: {
      bg: '#ecfdf5',
      secondary: '#d1fae5',
      text: '#065f46',
      textSecondary: '#047857',
      accent: '#10b981',
      card: '#ffffff',
      linkBg: '#10b98120',
      linkText: '#059669',
      linkHoverBg: '#10b98130',
    },
    dark: {
      bg: '#064e3b',
      secondary: '#065f46',
      text: '#d1fae5',
      textSecondary: '#6ee7b7',
      accent: '#10b981',
      card: '#065f46',
      linkBg: '#10b98120',
      linkText: '#34d399',
      linkHoverBg: '#10b98140',
    }
  }
};

export const lightTheme = {
  colors: {
    bg: '#f8fafc',
    secondary: '#e2e8f0',
    text: '#1e293b',
    textSecondary: '#64748b',
    accent: '#7c3aed', // Vibrant purple
    card: '#ffffff',
    linkBg: '#7c3aed20',
    linkText: '#7c3aed',
    linkHoverBg: '#7c3aed30',
  },
  gradients: {
    blur: {
      width: '600px',
      height: '600px',
      borderRadius: '600px',
      filter: 'blur(100px)',
      opacity: '0.15',
    }
  },
  breakpoints: {
    xs: '480px',
    sm: '640px',
    mobile: '768px',
    md: '768px',
    tablet: '1024px',
    lg: '1024px',
    desktop: '1280px',
    xl: '1280px',
    xxl: '1536px',
  },
  transitions: {
    default: 'all 0.3s ease',
    smooth: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  },
  typography: {
    fontFamily: '"Space Grotesk", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
    },
    fontWeight: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      none: 1,
      tight: 1.25,
      snug: 1.375,
      normal: 1.5,
      relaxed: 1.625,
      loose: 2,
    },
  },
  spacing: {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    8: '2rem',
    10: '2.5rem',
    12: '3rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    32: '8rem',
    40: '10rem',
    48: '12rem',
    56: '14rem',
    64: '16rem',
  },
};

export const darkTheme = {
  colors: {
    bg: '#0f172a',
    secondary: '#1e293b',
    text: '#f1f5f9',
    textSecondary: '#94a3b8',
    accent: '#8b5cf6', // Lighter purple for dark mode
    card: '#1e293b',
    linkBg: '#8b5cf620',
    linkText: '#a78bfa',
    linkHoverBg: '#8b5cf640',
  },
  gradients: lightTheme.gradients,
  breakpoints: lightTheme.breakpoints,
  transitions: lightTheme.transitions,
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.1)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.2), 0 2px 4px -1px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.2), 0 10px 10px -5px rgba(0, 0, 0, 0.1)',
  },
  typography: lightTheme.typography,
  spacing: lightTheme.spacing,
};